import NavMenuGroupHeader from './NavMenuGroupHeader.vue';

export default NavMenuGroupHeader;
